export default __webpack_public_path__ + "static/media/ic-clock-in.7494120d.svg";